import { IBasket } from "@/entities";
import { IOrder } from "@/entities/order/order";
import { IOrderRepository } from "@/repositories/order/order.types";
import { IOrderService } from ".";

// export const defaultBasket: IBasket = new Basket({
//     basketId: "",
//     basketName: "",
//     ownerId: "",
//     productList: [],
//     branchId: "any"
// });

export class OrderService implements IOrderService {
    constructor(private repository: IOrderRepository) { }

    async getOrderById(
        orderID: string,
        idToken: string
    ): Promise<IOrder | undefined> {
        return await this.repository.getOrder(orderID, idToken);
    }

    async createOrder(data: IOrder, idToken: string, group: string): Promise<IOrder> {
        switch (group) {
            case "Clickzy":
                {
                    console.log("clickzy order!");
                    const orderId = await this.repository.generateOrderId3rdparty(data.branchId!, "C");
                    // const orderId = await this.repository.generateOrderId(data.branchId!, idToken);
                    
                    data.orderId = orderId;
                    data.orderSource = "SALETOOL";
                    
                    return await this.repository.createOrder(data, idToken);
                }
            default:
                {
                    const orderId = await this.repository.generateOrderId(data.branchId!, idToken);
                    
                    data.orderId = orderId;
                    data.orderSource = "SALETOOL";
                    
                    return await this.repository.createOrder(data, idToken);
                }
        }
    }

    async getPOSOrder(orderID: string): Promise<any> {
        return this.repository.getPOSOrder(orderID);
    }

    // async syncBasket(basketData: IBasketData, apikey: string): Promise<IBasket> {
    //     const user = await this.getBasketById(basketData.basketId!, basketData.ownerId, apikey);
    //     if(user){
    //         return user;
    //     }
    //     return await this.createBasket(basketData, apikey);
    // }
}
